export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14263.1c7fd816.jpg";